// src/modules/Product/Page/Product.jsx
import React from "react";
import ProductBanner from "../Components/ProductBanner";
import ProductsAndFilter from "../Components/FilterProducts";
import { getSEOData } from "../../../global/utils/constants/seoConfig";
import "../Style/product.css";
import SEO from "../../../global/components/SEO/SEO";

const Product = () => {
  const seoData = getSEOData("/product");

  return (
    <>
      <SEO
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
        type="website"
      />
      <ProductBanner />
      <ProductsAndFilter />
    </>
  );
};

export default Product;
